var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.636353,
    width: 40,
    height: 40,
    rx: 20,
    className: "ext5_2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2885_13609)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ext5_2_i",
    d: "M30.304 17.6215C30.0841 16.3745 29.7363 15.4172 29.2659 15.1178C28.2329 14.4599 23.6765 14.3274 21.5389 14.3028C21.8202 14.2979 22.1015 14.3028 22.3827 14.3077H22.6435V13.1884C22.6435 13.0362 22.5515 12.9037 22.4185 12.8349L27.7215 9.66355C28.0283 9.48191 28.1255 9.09407 27.9363 8.79952C27.8493 8.65715 27.7062 8.55896 27.5374 8.51969C27.3635 8.48041 27.1845 8.50496 27.0363 8.59333L20.644 12.4177L14.2467 8.59333C13.9347 8.41168 13.541 8.50005 13.3415 8.80442C13.1626 9.1088 13.2597 9.48191 13.5665 9.66355L18.8747 12.8349C18.7417 12.9037 18.6548 13.0411 18.6548 13.1884V14.3126H18.9156C19.2173 14.3028 19.519 14.3028 19.8207 14.3028C17.7189 14.3225 13.0449 14.4501 12.0068 15.1178C11.0608 15.7216 10.6364 18.9421 10.6364 21.8631C10.6364 24.7841 11.0608 27.9997 12.012 28.6085C13.2802 29.4136 20.3372 29.4234 20.6389 29.4234C21.3906 29.4234 28.0232 29.4038 29.2659 28.6085C30.2119 27.9997 30.6364 24.7841 30.6364 21.8631C30.6364 20.4051 30.529 18.8685 30.304 17.6215ZM28.192 26.8608C28.1306 27.0375 28.0028 27.1504 27.8135 27.1897C26.5402 27.4646 23.789 27.6414 20.6389 27.6414C17.4888 27.6414 14.7581 27.4646 13.4643 27.1897C13.2802 27.1455 13.137 27.0277 13.0807 26.8608C12.3392 24.7154 12.3392 19.0256 13.0807 16.8851C13.1421 16.7084 13.27 16.5955 13.4592 16.5611C14.8706 16.2567 17.7547 16.1045 20.644 16.1045C23.5333 16.1045 26.4124 16.2567 27.8187 16.5562C28.0028 16.6004 28.1408 16.7231 28.2022 16.8851C28.5704 17.9553 28.7545 19.9043 28.7545 21.8484C28.7545 23.7925 28.5653 25.7856 28.192 26.8608Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ext5_2_i",
    d: "M15.7706 29.291L16.0058 29.3106V30.8619C16.0058 31.2841 15.4995 31.5001 14.9984 31.5001C14.4972 31.5001 13.9961 31.2841 13.9961 30.8619V29.1191L14.2825 29.1535C14.7427 29.2075 15.2439 29.2517 15.7706 29.291Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ext5_2_i",
    d: "M26.9902 29.1535L27.2817 29.1191V30.8619C27.2817 31.2841 26.7754 31.5001 26.2743 31.5001C25.7731 31.5001 25.2668 31.2841 25.2668 30.8619V29.3106L25.5021 29.291C26.0493 29.2517 26.5504 29.2026 26.9902 29.1535Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ext5_2_i",
    d: "M19.5905 18.0634C19.5905 18.2597 19.5036 18.4463 19.3502 18.5788L15.6018 22.1724C15.4535 22.3148 15.2643 22.3884 15.07 22.3884C14.8756 22.3884 14.6915 22.3148 14.5381 22.1724C14.2415 21.8877 14.2415 21.441 14.5381 21.1513L18.2916 17.5528C18.5882 17.2681 19.0587 17.2632 19.3553 17.5528C19.4985 17.6706 19.5905 17.8621 19.5905 18.0634Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ext5_2_i",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1293 18.2893V18.2991L15.6018 25.5158C15.4535 25.6582 15.2643 25.7318 15.07 25.7318C14.8756 25.7318 14.6915 25.6582 14.5381 25.5158C14.2415 25.231 14.2415 24.7843 14.5381 24.4947L22.0605 17.278C22.3571 16.9933 22.8224 16.9933 23.1242 17.278C23.4003 17.5677 23.4003 18.0095 23.1293 18.2893Z",
    fill: "#231F20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2885_13609"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ext5_2_i",
    width: 20,
    height: 23,
    fill: "white",
    transform: "translate(10.6364 8.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/Tv.abb1be0b.svg";
export { ForwardRef as ReactComponent };